import { connect } from 'react-redux'
import ParticipantsAudio from './ParticipantsAudio'
import { State } from '../../dataStore/reducers/reducerType'
import selectEnabledAudioTracks from '../../dataStore/selectors/selectEnabledAudioTracks'
import { ParticipantsAudioProps } from './types'

const mapStateToProps = (state: State, props): ParticipantsAudioProps => ({
  tracks: selectEnabledAudioTracks(state),
  muted: props.muted
})

export default connect(mapStateToProps)(ParticipantsAudio)
